import {Component, OnDestroy, OnInit} from '@angular/core';
import {Widget} from "../widget";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {Solicitud} from "../../../model/solicitudes/solicitud.model";
import {SolicitudIntraoral} from "../../../model/solicitudes/solicitud-intraoral.model";
import {SolicitudEscaneo} from "../../../model/solicitudes/solicitud-escaneo.model";
import {FilterAndData, FilterList} from "../../../api/filter-list";
import {ExactSearchFilter} from "../../../basic-entity-back/filters/search-filter";
import {map} from "rxjs/operators";

@Component({
    selector: 'app-solicitudes-pendientes-validar-widget',
    templateUrl: './solicitudes-pendientes-validar-widget.component.html',
    styleUrls: ['./solicitudes-pendientes-validar-widget.component.scss']
})
export class SolicitudesPendientesValidarWidgetComponent implements Widget, OnInit, OnDestroy {
    public static minCols = 1;
    public static minRows = 2;
    public static maxRows = 2;
    public static maxCols = 1;
    public static widgetName = 'Diseños analógicos pendientes de validar';
    public static widgetKey = 'pendientes-de-validar';
    public static link = 'solicitudes/escaneo/historico?$f-exs-0-estado="Pendiente de validación"';
    numeroSolicitudes: number = 0;
    private _interval: any;
    private _intervalSeconds = 10;

    constructor(private interfaceProvider: InterfaceProviderService) {
        this.execute();
    }

    ngOnInit(): void {
        this._interval = setInterval(
            () => this.execute(),
            this._intervalSeconds * 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this._interval);
    }

    private execute() {
        this.numeroSolicitudes = 0;

        const estadoProp = this.interfaceProvider.interfaceForModel(SolicitudEscaneo).mappingModelToApi['estado'];
        const filters: FilterList = [new FilterAndData(ExactSearchFilter, [Solicitud.ESTADOS_SOLICITUD.PENDIENTE_VALIDAR], estadoProp)];
        this.interfaceProvider.managerForModel(SolicitudEscaneo).loader.findAndFollow(filters).pipe(map(r => {
            return r.member;
        })).subscribe(ps => {
            this.numeroSolicitudes += ps.length;
        })
    }
}

